import React, { useEffect, useState } from 'react'
import Sidebar from '../AdminHome/Sidebar'
import MainContent from '../AdminHome/MainContent'
import Navbar from '../AdminHome/Navbar'
import { useParams } from 'react-router-dom';

import { getCheckout, updateCheckout } from '../../Redux/ActionCreator/CheckoutActionCreator'
import { useDispatch, useSelector } from 'react-redux';

export default function AdminCheckoutShow() {
    let [data, setData] = useState({})
    let [flag, setFlag] = useState(false)
    let [orderStatus, setOrderStatus] = useState("")
    let [paymentStatus, setPaymentStatus] = useState("")
    let { _id } = useParams()
    let dispatch = useDispatch()
    let CheckoutStateData = useSelector(state => state.CheckoutStateData)

    function updateRecord() {
        if (window.confirm("Are you really want to change the status?")) {
            let item = CheckoutStateData.find((x) => x._id === _id)
            dispatch(updateCheckout({ ...item, orderStatus: orderStatus, paymentStatus: paymentStatus }))
            setFlag(!flag)
            setData((old) => {
                return {
                    ...old,
                    orderStatus: orderStatus, paymentStatus: paymentStatus
                }
            })
        }
    }


    async function getAPIData() {
        dispatch(getCheckout())
        if (CheckoutStateData.length) {
            let item = CheckoutStateData.find((x) => x._id === _id)
            setData(item)
            setOrderStatus(item.orderStatus)
            setPaymentStatus(item.paymentStatus)

        }
        else
            setData([])
    }

    useEffect(() => {
        getAPIData()
    }, [CheckoutStateData.length])


    return (
        <>
            <div className='app d-flex'>
                <Sidebar />
                <MainContent>
                    <Navbar />
                    <div className="container-fluid my-3">
                        <div className="text-center p-2 bg-info mx-3 my-4">
                            <span className='text-white fs-4'>Order Show</span>
                        </div>

                        <div className="mx-3">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="testimonial-item img-border-radius shadow-sm bg-white p-4">
                                        <span className='float-end text-primary'>{new Date(data.date).toDateString()}</span>

                                        {data.products?.map((product, idx) => (
                                            <div key={idx} className="row">
                                                <div className="col-md-3 mb-1">
                                                    <img src={`/${product.product?.pic}`} height={100} width="100%" alt="" />
                                                </div>
                                                <div className='col-md-9'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div>
                                                            <h6>{product.product?.name}</h6>
                                                            <span><strong>Brand</strong>: {product.product?.brand?.name}</span>,
                                                            <span><strong>Color</strong>: {product.product?.color}</span>,
                                                            <span><strong>Size</strong>: {product.product?.size}</span>
                                                            <p><strong>Quantity</strong>: {product.qty} * &#8377; {product.product?.finalPrice} </p>
                                                            <span>&#8377; {product.total}</span>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="testimonial-item img-border-radius shadow-sm bg-white p-4">
                                        <h6>Delivery Info</h6>
                                        <span><strong>{data.user?.name}</strong>, {data.user?.address}, {data.user?.city}, {data.user?.state}-<strong>{data.user?.pin}</strong>, (+91) {data.user?.phone}</span>

                                        <h6 className='mt-3'>Payment Info</h6>
                                        <p className='extra'>Payment Mode: {data.paymentMode}</p>
                                        <p className='extra'>Payment Status:
                                            {
                                                data.paymentStatus !== "Done" ?
                                                    <>
                                                        <select name="paymentStatus" value={paymentStatus} onChange={(e) => setPaymentStatus(e.target.value)} className='px-1 ms-2 border-dark rounded' >
                                                            <option>pending</option>
                                                            <option>Done</option>

                                                        </select>
                                                    </> : <>
                                                        <span className='bg-success px-2 ms-1 rounded text-white'>{data.paymentStatus}</span>
                                                    </>
                                            }
                                        </p>

                                        <p className='extra'>Subtotal: &#8377;{data.subtotal}</p>
                                        <p className='extra'>Shipping: &#8377;{data.delivery}</p>
                                        <p className='extra'>Total Amount: &#8377;{data.total}</p>

                                        <h6 className='mt-3'>Order Info</h6>
                                        <p>Order Status:
                                            {
                                                data.orderStatus !== "Delivered" ?
                                                    <>
                                                        <select name="orderStatus" value={orderStatus} onChange={(e) => setOrderStatus(e.target.value)} className='px-2 ms-2 border-dark rounded' >
                                                            <option>Order Confirmed</option>
                                                            <option>Shipped</option>
                                                            <option>Out for Delivery</option>
                                                            <option>Delivered</option>
                                                        </select>
                                                    </> : <>
                                                        <span className='bg-danger px-2 ms-1 rounded text-white'>{data.orderStatus}</span>
                                                    </>
                                            }
                                        </p>
                                        {
                                            data.paymentStatus !== "Done" || data.orderStatus !== "Delivered" ? <button onClick={updateRecord} className='btn bg-info text-dark w-100'>Update Status</button> : ""
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </MainContent>
            </div>
        </>
    )
}
